import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';

import LayoutContainer from '../LayoutContainer/LayoutContainer';
import { paymentPropTypes } from '../../../states/payments/propTypes';
import envConfigPropTypes from '../../../states/envConfig/propTypes';
import { goToReview } from '../../../states/page/actions';
import { setEditMode, setPaymentType } from '../../../states/modes/actions';
import { initialiseBatch } from '../../../states/batch/actions';
import {
	updateTemplateName,
	resetCurrentTemplate,
	initialisePaymentsForTemplate,
} from '../../../states/templates/actions';
import { initialisePayments } from '../../../states/payments/actions';
import { TYPE_FASTER_PAYMENTS } from '../../../config';
import { isAuthorisationEdit } from '../../../states/modes/selectors';

const mapDispatch = (dispatch) => ({
	initialisePayments: (payments) => dispatch(initialisePayments(payments)),
	initialisePaymentsForTemplate: (payments, templateName) =>
		dispatch(initialisePaymentsForTemplate(payments, templateName)),
	initialiseBatch: (batchDetails) => dispatch(initialiseBatch(batchDetails)),
	goToReview: () => dispatch(goToReview()),
	resetCurrentTemplate: () => dispatch(resetCurrentTemplate()),
	updateTemplateName: (templateName) => dispatch(updateTemplateName(templateName)),
	setPaymentType: (paymentType) => dispatch(setPaymentType(paymentType)),
	setEditMode: (payments) => dispatch(setEditMode(payments)),
});

const mapState = (state) => ({
	isAuthorisationEdit: isAuthorisationEdit(state),
});

class App extends Component {
	constructor(props) {
		super(props);
		const {
			multiTransactions,
			payments,
			paymentDetails: { batchDetails } = {},
			isAuthorisationEdit,
			templateName,
			initialisePaymentsForTemplate,
			setEditMode,
			initialisePayments,
			initialiseBatch,
			resetCurrentTemplate,
			updateTemplateName,
			isManagePaymentEdit,
			setPaymentType,
		} = this.props;
		if (isAuthorisationEdit || isManagePaymentEdit) {
			setEditMode(payments);
		}

		if (payments && payments.length > 0) {
			if (templateName) {
				resetCurrentTemplate();
				initialisePaymentsForTemplate(payments);
				updateTemplateName(templateName);
			} else {
				initialisePayments(payments);
			}
		}
		if (batchDetails) {
			initialiseBatch(batchDetails);
		}

		if (multiTransactions) {
			this.props.handleDisplayFullwidth();
		}

		setPaymentType({ paymentType: TYPE_FASTER_PAYMENTS });
	}

	componentDidUpdate(prevProps) {
		const { initialisePayments, initialiseBatch, payments, paymentDetails, isAuthorisationEdit } = this.props;

		// if (!isEqual(multiTransactions, prevProps.multiTransactions)) {
		// 	setMultiTransactions(multiTransactions));
		// 	if (multiTransactions) {
		// 		this.props.handleDisplayFullwidth();
		// 	}
		// }
		//
		// if (!isEqual(accounts, prevProps.accounts)) {
		// 	setAccounts(accounts));
		// }
		//
		// if (!isEqual(payees, prevProps.payees)) {
		// 	setPayees(payees));
		// }

		if (payments && payments.length > 0 && !isEqual(payments, prevProps.payments) && !isAuthorisationEdit) {
			initialisePayments(payments);
			this.props.handleDisplayFullwidth();
		}
		if (!isEqual(paymentDetails, prevProps.paymentDetails)) {
			initialiseBatch(paymentDetails.batchDetails);
		}

		// if (!isEqual(isAuthorisationEdit, prevProps.isAuthorisationEdit)) {
		// 	setIsAuthorisationEdit(isAuthorisationEdit));
		// 	setEditMode(payments));
		// }
		//
		// if (!isEqual(user, prevProps.user)) {
		// 	setUser(user));
		// }
	}

	render() {
		const {
			copCheckTriggered,
			handleRoute,
			handleBack,
			resetPaymentList,
			handleAddPayee,
			handleComplete,
			handleDisplayFullwidth,
			handlePaymentInReview,
			handleSelectPaymentType,
			envConfig,
			isBootStrapInProgress,
			sessionCOPChecks,
		} = this.props;
		return (
			<WebUIThemeProvider brandID={envConfig.brandId}>
				<LayoutContainer
					copCheckTriggered={copCheckTriggered}
					handleRoute={handleRoute}
					handleBackParent={handleBack}
					resetPaymentList={resetPaymentList}
					handleAddPayee={handleAddPayee}
					handleComplete={handleComplete}
					handleDisplayFullwidth={handleDisplayFullwidth}
					handlePaymentInReview={handlePaymentInReview}
					handleSelectPaymentType={handleSelectPaymentType}
					isBootStrapInProgress={isBootStrapInProgress}
					sessionCOPChecks={sessionCOPChecks}
				/>
			</WebUIThemeProvider>
		);
	}
}

App.propTypes = {
	handleRoute: PropTypes.func.isRequired,
	handlePaymentInReview: PropTypes.func,
	handleBack: PropTypes.func,
	multiTransactions: PropTypes.bool.isRequired,

	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	handleAddPayee: PropTypes.func.isRequired,
	isManagePaymentEdit: PropTypes.bool.isRequired,
	isAuthorisationEdit: PropTypes.bool.isRequired, // create, edit
	paymentDetails: PropTypes.shape({
		batchDetails: PropTypes.shape({
			batchId: PropTypes.string.isRequired,
			isBatch: PropTypes.bool.isRequired,
			batchName: PropTypes.string.isRequired,
		}),
	}),
	payments: PropTypes.arrayOf(PropTypes.shape(paymentPropTypes)),
	resetPaymentList: PropTypes.func,
	handleComplete: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	user: PropTypes.shape({ id: PropTypes.string }),
	handleSelectPaymentType: PropTypes.func.isRequired,
	templateName: PropTypes.string,
	initialisePaymentsForTemplate: PropTypes.func.isRequired,
	setEditMode: PropTypes.func.isRequired,
	initialisePayments: PropTypes.func.isRequired,
	initialiseBatch: PropTypes.func.isRequired,
	resetCurrentTemplate: PropTypes.func.isRequired,
	updateTemplateName: PropTypes.func.isRequired,
	setPaymentType: PropTypes.func.isRequired,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};

export default connect(mapState, mapDispatch)(App);
